var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { px, styled } from '../styles';
var Wrapper = styled('div')({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    '> *': {
        width: '100%',
        '@media (min-width: 1024px)': {
            width: '33.3333%',
        },
    },
    '@media (min-width: 1024px)': {
        flexDirection: 'row',
    },
}, function (_a) {
    var style = _a.style;
    return ({
        minHeight: px(style.h),
    });
}, 'ContentRSWP');
export default function Content(_a) {
    var children = _a.children, styles = _a.styles;
    return _jsx(Wrapper, __assign({ style: { h: styles.height } }, { children: children }));
}
//# sourceMappingURL=Content.js.map